import { useContext } from 'react'
import { parseLink } from '../constants/externalLinks'
import CountryLangCtx from 'app/contexts/countryLang/CountryLangCtx'

export default function useLocalization () {
  const { country, language } = useContext(CountryLangCtx)
  return { parseLink: (link) => parseLink(link, country, language) }
}
